import adultTeeth from "@/components/TeethWidget/adultTeeth";
import childTeeth from "@/components/TeethWidget/childTeeth";

export const getToothIDByPosition = (position: number) => {
  return (
    adultTeeth.find((t) => t.position === position)?.id ||
    childTeeth.find((t) => t.position === position)?.id
  );
};
